import styled from 'styled-components';
import { useState } from 'react';
import SaleTypeTabs from './SaleTypeTabs';
import CompoundSearchResults from './CompoundSearchResults';
import Header from './Header';
import { PropertySaleType } from '../../../types';
import { Compound } from '../../../../../new-lib/types/entity';
import { CompoundSummaryDto } from '../../../dtos';

interface AvailableProperties {
  compound: Compound | CompoundSummaryDto;
}
const AvailableProperties = ({ compound }: AvailableProperties) => {
  const [activeSaleTab, setActiveSaleTab] = useState<PropertySaleType>(
    PropertySaleType.All
  );

  return (
    <Container>
      {compound?.prices?.developerStartingPrice > 0 &&
        compound?.prices?.resaleStartingPrice > 0 && (
          <>
            <Header />

            <SaleTypeTabs
              activeSaleTab={activeSaleTab}
              setActiveSaleTab={setActiveSaleTab}
            />
          </>
        )}

      <CompoundSearchResults
        compound={compound}
        activeTab={activeSaleTab}
        propertiesImagesSize="high"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 80px;

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    gap: 24px;
  }
`;

export default AvailableProperties;
